import React from "react";
import "./Careers.css"; 
import Footer from "../components/Footer";

const Careers = () => {
  return (
    <div className="careers-page">
      {/* ... Hero Section ... */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Start Your Journey with Us</h1>
          <p>
            A career at our company is more than just a job—it's a chance to be
            a part of a community dedicated to building, innovating, and making
            a real impact. Join a workforce that drives change and delivers
            excellence.
          </p>
          <button className="btn-apply">Apply Now</button>
        </div>
        <div className="hero-image">
          <img src="path-to-hero-image" alt="Workplace Team" />
        </div>
      </section>

      {/* ... Why Join Us ... */}
      <section className="why-join">
        <h2>Why Work With Us?</h2>
        <div className="join-content">
          <div className="join-card">
            <h3>Stable Income & Benefits</h3>
            <p>
              Competitive wages, health insurance, paid leave, and other
              benefits that ensure a secure future for you and your family.
            </p>
          </div>
          <div className="join-card">
            <h3>Growth Opportunities</h3>
            <p>
              We offer hands-on experience, training programs, and internal
              promotions to help you develop your career.
            </p>
          </div>
          <div className="join-card">
            <h3>Community & Culture</h3>
            <p>
              Be part of a team that cares. We value collaboration, support, and
              respect for every individual.
            </p>
          </div>
        </div>
      </section>

      {/* ... Testimonials ... */}
      <section className="testimonials">
        <h2>What Our Workers Say</h2>
        <div className="testimonial-card">
          <p>
            "I've been with the company for over 10 years, and it's been a
            life-changing experience. The pay is great, but it's the camaraderie
            that keeps me coming back."
          </p>
          <p>- John D., 10 Years in Construction</p>
        </div>
        <div className="testimonial-card">
          <p>
            "This company has always made me feel like part of the family. They
            invest in their employees and give us the chance to grow."
          </p>
          <p>- Maria R., 7 Years in Manufacturing</p>
        </div>
        <div className="testimonial-card">
          <p>
            "From day one, I felt supported. I’ve received ongoing training
            that’s helped me excel and expand my skill set."
          </p>
          <p>- Ahmed S., 5 Years in Logistics</p>
        </div>
      </section>

      {/* ... Open Positions ... */}
      <section className="open-positions">
        <h2>Explore Current Job Openings</h2>
        <div className="job-list">
          <div className="job-item">
            <h3>Construction Worker</h3>
            <p>Location: New York, NY</p>
            <button className="btn-apply">Apply Now</button>
          </div>
          <div className="job-item">
            <h3>Warehouse Associate</h3>
            <p>Location: Los Angeles, CA</p>
            <button className="btn-apply">Apply Now</button>
          </div>
          <div className="job-item">
            <h3>Delivery Driver</h3>
            <p>Location: Chicago, IL</p>
            <button className="btn-apply">Apply Now</button>
          </div>
        </div>
      </section>

      {/* ... Benefits ... */}
      <section className="benefits">
        <h2>Our Employee Benefits</h2>
        <div className="benefit-list">
          <div className="benefit-item">
            <h3>Health & Wellness</h3>
            <p>
              Comprehensive health insurance packages to keep you and your
              family covered.
            </p>
          </div>
          <div className="benefit-item">
            <h3>Paid Time Off</h3>
            <p>
              Enjoy paid holidays, vacation days, and personal time to maintain
              work-life balance.
            </p>
          </div>
          <div className="benefit-item">
            <h3>Training & Development</h3>
            <p>
              On-the-job training and career development opportunities to help
              you grow in your field.
            </p>
          </div>
        </div>
      </section>

      {/* ... Contact Us ... */}
      <section className="contact-us">
        <h2>Have Questions? Get in Touch!</h2>
        <p>
          If you have any questions about the application process or need more
          information, don't hesitate to reach out.
        </p>
        <button className="btn-apply">Contact Us</button>
      </section>

      {/* Shared Footer component */}
      <Footer />
    </div>
  );
};

export default Careers;
